<template>
  <v-btn icon @click="$emit('click')">
    <v-icon>mdi-pencil</v-icon>
  </v-btn>
</template>

<script>
export default {};
</script>

<style></style>
